module.exports = __webpack_public_path__ + "img/PRISE_MEDICAMENTS_ACTIVE.9c929c92.svg";